import script from "./CollectionLook.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollectionLook.vue?vue&type=script&lang=ts&setup=true"

import "./CollectionLook.vue?vue&type=style&index=0&id=7d7fc583&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d7fc583"]])

export default __exports__